import Http from "@/commons/Http";
import CachedApi from "@/commons/CachedApi";

const path = 'api/tag';

export default {

  async getAll(){
    return CachedApi.getCached('get-all-tags', async () => {
      return Http.get(`${path}`);
    }, false);
  },

  async getByTipo(tipo){
    return CachedApi.getCached(`get-tags-by-tipo-${tipo}`, async () => {
      return Http.get(`${path}/tipo/${tipo}`);
    }, false);
  },

  async getByTipoAtivas(tipo){
    return CachedApi.getCached(`get-tags-by-tipo-ativas-${tipo}`, async () => {
      return Http.get(`${path}/tipo/${tipo}/ativas`);
    }, false);
  },

  async getSimpleList(){
    return Http.get(`${path}/simple`);
  },

  async getById(id){
    return Http.get(`${path}/${id}`);
  },

  async save(dto, id = ''){
    const result = await Http.post(`${path}/${id}`, dto);
    CachedApi.invalidate('get-all-tags');
    return result;
  },

  async saveByName(dto){
    const result = await Http.post(`${path}/save-by-name`, dto);
    CachedApi.invalidate('get-all-tags');
    return result;
  },

  async delete(id){
    const result = await Http.delete(`${path}/${id}`);
    CachedApi.invalidate('get-all-tags');
    return result;
  },

  async getTiposVinculo(){
    return Http.get(`${path}/tipo-vinculo`);
  },

  async getByVinculo(id, tipo){
    return Http.get(`${path}/tags-vinculo/${id}/${tipo}`);
  },

}
